export enum ApiEnum {
    urlApiAuth = "tolifecloud-api-auth/",
    urlApiSrvEmail = "tolifecloud-api-srvemail/",
    urlApiAdminUser = "tolifecloud-api-admin-user/",
    urlApiUser = "tolifecloud-api-user/",
    urlApiOrchestratorIntegration = "integration/",
    urlApiSrvLog = "tolifecloud-api-srvlog/",
    urlApiDevice = "tolifecloud-api-device/",
    urlApiRiskClassification = "tolifecloud-api-risk-classification/",
    urlApiReport = "tolifecloud-api-report/",
    urlApiBilling = "tolifecloud-api-billing/",
    urlApiBusinessIntelligence = "tolifecloud-api-business-intelligence/",
    urlApiPharmacy = "tolifecloud-api-pharmacy/",
    urlApiNotification = "tolifecloud-api-notification/",
    urlApiOrchestratorUser = "tolifecloud-api-orchestrator-user/",
    urlApiIntegration = "tolifecloud-api-integration/",
    urlApiEmerges = "emerges-key/",
    urlApiSelfTriage = "tolifecloud-api-self-triage/",
    urlApiIntegrationRelationConfig = "tolifecloud-api-integration-relation-config/",
    urlApiIntegrationIT4D = "tolifecloud-api-integration-it4d/",
    urlApiIntegrationFastMedic = "tolifecloud-api-integration-fastmedic/",
    urlApiEmergesKey = "tolifecloud-api-emerges-key/",
    urlApiMedicalRecord = "tolifecloud-api-medical-record/",
    urlApiIntegrationSiga = "tolifecloud-api-integration-siga/",
    urlApiBillingByHealthUnit = "tolifecloud-api-billing-by-health-unit/",
    urlApiOrchestratorBillingByHealthUnit = "tolifecloud-api-orchestrator-billing-by-health-unit/",
    urlApicareLinePriority = "tolifecloud-api-care-line-priority/",
    urlApiCsat = "tolifecloud-api-csat/",
    urlApiSRVMessageQueue = "tolifecloud-api-srv-message-queue/",
    urlApiOrchestratorBusinessIntelligence = "tolifecloud-api-orchestrator-business-intelligence/",
    urlApiCache = "tolifecloud-api-cache/",
    urlApiDataMesh = "tolifecloud-api-data-mesh/",
    urlApiOrchestratorClassification = "tolifecloud-api-orchestrator-classification/",
    urlApiFlow = "tolifecloud-api-flow/"
}